import { extendTheme } from '@chakra-ui/react';
import textStyles from './textStyles';
import semanticTokens from './semanticTokens';
import colors from './colors';
import Button from './button';
import Input from './input';
import Select from './select';
import Textarea from './textarea';
import Badge from './badge';
import Link from './link';

const theme = extendTheme({
  colors,
  textStyles,
  semanticTokens,
  styles: {
    global: {
      // styles for the `body`
      body: {
        bg: 'body-bg',
        color: 'gray.800',
      },
      // styles for the `a`
      a: {
        _hover: {
          textDecoration: 'none',
        },
      },
    },
  },
  layerStyles: {
    notoSansTC: {
      fontFamily: 'var(--font-noto-sans-tc)',
    },
    poppins: {
      fontFamily: 'var(--font-poppins), var(--font-noto-sans-tc)',
    },
  },
  components: {
    Button,
    Input,
    Select,
    Textarea,
    Badge,
    Link,
  },
});

export default theme;
